import React, { Component, Fragment } from 'react';
import { 
    Checkbox,
    TableContainer,
    Table,
    TableBody,
    TableCell,
    TableRow,
    TableFooter,
    TablePagination,
} from '@mui/material';
import Dialog from '../../common/Dialog';
import { EnhancedTableHead, EnhancedTableToolbar } from '../../../container/MUI/EnhancedTable';
import FilterSpendings from '../../Spendings/FilterSpendings';
import Pagination from '../../../container/MUI/Pagination';

import { isEmpty, size } from "lodash";
import { normalizeStr } from '../../../utils/generalFuncs';
import Currency from '../../common/Currency';

class AddSpending extends Component {
    state = { 
        page: 0,
        rowsPerPage: 20,

        newSpending : false,
        validateSpending : false,
        openDetails: false, 
        selectedSpending: {},
        
        openSupplier: false,
        selectedSupplier: {},
        openLabel: false,
        selectedLabel: {},

        filteredList: Object.values(this.props.SPENDINGS),
        spending: {},
        toDelete: {},

        checkedSpendings: [],
        singlePayment: [],

        searchLabel: "",
        searchCategory: {value: "", label: ""},
        searchSubCategory: "",
        searchSupplier: "",
        pay_status: "all",

        openFilters: false,
        anchorEl: null, 
        openMenu: "", 
        loading: false,
        url: ""
    }
    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ page: 0, rowsPerPage: parseInt(event.target.value) });
    };
    handleChange = (e) => {
        const { name, value} = e.target;
        if (name === "searchCategory"){
            this.setState({
                searchSubCategory: "",
                searchSubCategory2: "",
                [name]: value,
                page:0,
            })
        } else if (name === "searchSubCategory"){
            this.setState({
                searchSubCategory2: "",
                [name]: value,
                page:0,
            })
        } else {
            this.setState({
                [name]: value,
                page:0,
            })
        }
    }
    handleChangeMulti = (option, field) => {
        console.log('====================================');
        console.log({option, field});
        console.log('====================================');
        if (field === "searchCategory" && !isEmpty(option.value)){
            this.setState({
                searchSubCategory: "",
                searchSubCategory2: "",
                [field]: option,
                page: 0,
            })
        } else if(option){
            this.setState({                
                [field]: option,
                page: 0,
                // checkedItems :[]
            })
        } else {
            this.setState({
                [field]: {label: "", value: ""},
                page: 0,
                // checkedItems :[]
            })

        }
    }
    filterLabels = (spending) => {
        const { LABELS } = this.props;
        const { searchLabel } = this.state;
        let match = false

        if (searchLabel) {
            if (spending.spending_labels) {
                let searchLabels = searchLabel.split(", ") //!\ Namelist
                let spendingIDList = spending.spending_labels.split(", ") //!\ IDlist
                let spendingLabelsList = []
                spendingIDList.forEach( 
                    labelID => (
                        LABELS && LABELS[labelID] && spendingLabelsList.push( normalizeStr(LABELS[labelID].label_name) )
                    )
                )

                let nbMatch = 0 
                searchLabels.forEach( searching => {
                    let find = spendingLabelsList.filter( label => label.indexOf(normalizeStr(searching)) > -1)

                    if(!isEmpty(find)){
                        nbMatch++
                        spendingLabelsList.splice(spendingLabelsList.indexOf(find[0]), 1) // to prevent double match on same item
                    } 
                })
                match = nbMatch === size(searchLabels)

            } else {
                match = false
            }
        } else {
            match = true
        }
        return match
    }
    filterSuppliers = (spending) => {
        const { SUPPLIERS } = this.props;
        const { searchSupplier } = this.state;
        let match = false

        if (searchSupplier && SUPPLIERS) {
            if (spending.spending_supplier) {

                let searching = searchSupplier.split(", ") 
                let supplier = normalizeStr(SUPPLIERS[spending.spending_supplier].supplier_name)
                
                searching.forEach( search => {
                    if(supplier.indexOf(normalizeStr(search)) > -1 ) {
                        match = true
                    }
                })

            } else {
                match = false
            }
        } else {
            match = true
        }
        return match
    }
    
    filterCat = (list) => {
        const { CATEGORIES } = this.props;
        const { searchCategory } = this.state;
        let newList = []
        console.log('====================================');
        console.log({searchCategory});
        console.log('====================================');
        list.forEach(item => {
            if( !searchCategory.value ) {
                newList.push(item) 
            } else if( CATEGORIES.ALL[searchCategory.value].includes(item.spending_category) ) {
                newList.push(item) 
            }
        })
        
        return newList
    }
    filterSubCat = (list) => {
        const { ALL, LIST } = this.props.CATEGORIES;
        const { searchSubCategory } = this.state;
        let newList = []

        list.forEach(item => {
            if( !searchSubCategory ) {
                newList.push(item) 
            } else if( item.spending_category === searchSubCategory ) {
                newList.push(item) 
            } else if ( LIST[searchSubCategory] && LIST[searchSubCategory].includes(item.spending_category)) {
                newList.push(item) 
            }
        })
        return newList
    }
    filterSubCat2 = (list) => {
        const { searchSubCategory2 } = this.state;
        let newList = []

        list.forEach(item => {
            if( !searchSubCategory2 ) {
                newList.push(item) 
            } else if( item.spending_category === searchSubCategory2) {
                newList.push(item) 
            }
        })
        return newList
    }

    getFilteredList = () => {
        const { SPENDINGS } = this.props;
        // labels
        let list = Object.values(SPENDINGS).filter(item => this.filterLabels(item))
        list = list.filter(item => (item.spending_status === "VALIDATE"))
        // suppliers
        list = list.filter(item => this.filterSuppliers(item))
        // categories
        list = this.filterCat(list)
        // subCat
        list = this.filterSubCat(list)
        // subCat2
        list = this.filterSubCat2(list)

        return list
    }

    displayLabels = (labels) => {
        const { LABELS } = this.props;
        return labels.split(', ').map(label => LABELS && LABELS[label] && LABELS[label].label_name)
    }

    handleSelectAllClick = event => {
        if (event.target.checked) {
            let filteredList = this.getFilteredList()
            const newSelecteds = filteredList.map(item => item.spending_id);
            this.setState({
                checkedSpendings : newSelecteds
            });
          return;
        }
        this.setState({
            checkedSpendings :[]
        });
        
      };
    
    handleClick = (event, name) => {
        const { checkedSpendings } = this.state;
        const selectedIndex = checkedSpendings.indexOf(name);
        let newSelected = [];
    
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(checkedSpendings, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(checkedSpendings.slice(1));
        } else if (selectedIndex === checkedSpendings.length - 1) {
            newSelected = newSelected.concat(checkedSpendings.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                checkedSpendings.slice(0, selectedIndex),
                checkedSpendings.slice(selectedIndex + 1),
            );
        }
    
        this.setState({
            checkedSpendings : newSelected
        });
    };
    displayList = () => {
        const { SPENDINGS } = this.props;
        let tab = []
        let rows = 0
        if (!isEmpty(SPENDINGS)){
            let filteredList = this.getFilteredList()
            rows = size(filteredList)
            tab.push( this.getSpendingList(filteredList))
        }
        return [tab, rows]
    }
    getSpendingList = (list, bckg) => {
        const { rowsPerPage, page, checkedSpendings } = this.state;
        const { LABELS, SUPPLIERS } = this.props;

        const isSelected = name => checkedSpendings.indexOf(name) !== -1;

        return list.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map( (item, index) => {

            // let category = CATEGORIES.CHILD[item.spending_category]
            // let user = isEmpty(USERS) ? {} : USERS[item.spending_user]
            // let userInfo = (user.username && user.lastname) ? `${user.username[0]}.${user.lastname[0]}.` : user.email

            let labels = LABELS && item.spending_labels && item.spending_labels.split(", ")
            let supplier = isEmpty(SUPPLIERS) ? {} : SUPPLIERS[item.spending_supplier]

            let isItemSelected = isSelected(item.spending_id)
            const labelId = `enhanced-table-checkbox-${index}`;

            return (
                <TableRow hover key={item.spending_id} className="clickable" style={{ backgroundColor: bckg }} 
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={item.spending_id}
                    selected={ isItemSelected }
                    onClick={event => this.handleClick(event, item.spending_id)}
                >
                    <TableCell 
                        padding="checkbox"
                    >
                    
                    <Checkbox
                        checked={isItemSelected}
                        inputProps={{ 'aria-labelledby': labelId }}
                    />
                    
                    </TableCell>
                    
                    <TableCell>
                        {new Date(item.spending_date).toLocaleDateString('fr-FR')}
                    </TableCell>     
                    <TableCell>
                        {item.spending_desc}
                    </TableCell>   
                    <TableCell>
                        {supplier && supplier.supplier_name}
                    </TableCell>   
                    <TableCell >
                        {labels && labels.map( (label, index) =>
                        <Fragment key={label}>
                            {index !== 0 && " | "}
                            <span >
                                {LABELS[label].label_name}
                            </span> 
                        </Fragment>
                        )}
                    </TableCell>   
                    <TableCell>
                        <Currency value={item.spending_amountTTC} />
                    </TableCell>                     
                </TableRow>
            )
        })
    }
    handleSubmit = async () => {
        const { checkedSpendings } = this.state;
        console.log('====================================');
        console.log({ checkedSpendings }, this.props.chantier.chantier_id);
        console.log('====================================');
        await this.props.addSpendingToChantier(checkedSpendings, this.props.chantier.chantier_id)
        
        if(this.props.STATE.chantiers.error){
            console.log('====================================');
            console.log("ERROR", this.props.STATE.chantiers );
            console.log('====================================');
            this.props.notif("error",`Un problème est survenu: ${this.props.STATE.chantiers.error}`)
        } else {
            this.props.notif("success","Le projet a été modifiée avec succès")
            this.props.handleClose()
        }
    }
    render() {
        const { 
            page, 
            rowsPerPage, 
            openFilters, 
            checkedSpendings,
        } = this.state;
    
        const { SPENDINGS, CATEGORIES } = this.props;
        const spendingsList = this.displayList()

        return (
            <Dialog
                close={this.props.handleClose}
                title={`${this.props.chantier_name} : Ajouter des dépenses`}
                submitAction={this.handleSubmit} 
                disabledSubmit={this.props.STATE.chantiers.fetching}
                submitTitle={"Ajouter"}
                maxWidth="lg"
            >
                <FilterSpendings 
                    CATEGORIES={CATEGORIES}
                    handleClose={() => this.setState({ openFilters: false })}
                    handleChange={this.handleChange}
                    handleChangeMulti={this.handleChangeMulti}
                    admin
                    noPaymentFilter
                    {...this.state}
                />

                    {/* <FilterSpendings 
                        CATEGORIES={CATEGORIES}
                        USERS={USERS}
                        SUPPLIERS={SUPPLIERS}
                        LABELS={LABELS}
                        handleClose={() => this.setState({ openFilters: false })}
                        handleChange={this.handleChange}
                        handleChangeMulti={this.handleChangeMulti}
                        admin
                        {...this.state}
                    />
                 */}

                {!isEmpty(checkedSpendings) &&
                    <EnhancedTableToolbar 
                        numSelected={checkedSpendings.length} 
                    />
                }
                <TableContainer>
                    <Table>
                        <EnhancedTableHead
                            numSelected={size(checkedSpendings)}
                            onSelectAllClick={this.handleSelectAllClick}
                            rowCount={spendingsList[1]}
                            headers ={ [
                                { id: 'spending_date', numeric: false, disablePadding: false, label: 'Créé le' },
                                { id: 'spending_desc', numeric: false, disablePadding: false, label: 'Description' },
                                { id: 'spending_supplier', numeric: false, disablePadding: false, label: 'Fournisseur' },
                                { id: 'spending_labels', numeric: false, disablePadding: false, label: 'Labels' },
                                { id: 'spending_amount', numeric: true, disablePadding: false, label: 'Montant' },
                              ]}
                        />
                    
                        <TableBody>
                            {spendingsList[0]}
                        </TableBody>
                        {spendingsList[1] > 10 &&
                            <TableFooter>
                                <TableRow>
                                    <TablePagination
                                        rowsPerPageOptions={[20, 30]}
                                        labelRowsPerPage="Lignes par Page"
                                        colSpan={10}
                                        count={spendingsList[1]}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        SelectProps={{
                                            native: true,
                                        }}
                                        onPageChange={this.handleChangePage}
                                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                                        ActionsComponent={Pagination}
                                    />
                                </TableRow>
                            </TableFooter>
                        }
                    </Table> 
                </TableContainer>
            </Dialog>
        );
    }
}

export default AddSpending;